export default __webpack_public_path__ + "static/media/logout.f40e7d31.svg";